import {HABITAT_FAMILY_LABELS} from "../../../helpers/habitat-classification/constants";

export const HABITAT_REVIEW_FAMILY_OPTIONS = [...HABITAT_FAMILY_LABELS];
export const HABITAT_REVIEW_DEFAULT_REASON = 'Manual review';
export const HABITAT_REVIEW_ROUTE = '/hotspot-explorer/habitat-review';
